import React from 'react'
import { ReferenciaContenido } from '../../../interfaces/ReferenciaContenido'
import GridCardsSection from '../../organisms/grid-cards-section/girdCardsSection'
import CardColumns from '../../molecules/card-colums/cardColumns'
import ContentLeftRight from '../../molecules/content-left-right/contentLeftRight'
import Gallery from '../../organisms/gallery/gallery'
import GalleryExtended from '../../organisms/gallery-extended/galleryExtended'
import VideoLink from '../../molecules/video-link/videoLink'
import SubsectionContainer from '../../molecules/subsection-container/subsectionContainer'
import DiscoverAppSection from '../../molecules/discover-app/discoverAppSection'
import DownloadsList from '../../molecules/downloads-list/downloadsList'
import OfficesList from '../../molecules/offices-list/officesList'
import GalleryCards from '../../organisms/gallery-cards/galleryCards'
import Richtext from '../../molecules/richtext/richtext'
import VideoService from '../../organisms/video-service/videoService'
import FrequentlyAskedQuestions from '../../molecules/frequent-questions/frequent-questions'
import ArticleContentDescription from '../../molecules/article-content-description/articleContentDescription'
import SpotifyListen from '../../atoms/spotify-listen/spotifyListen'
import Readtime from '../../atoms/readtime/readTime'
import PriceInformation from '../../organisms/price-information/priceInformation'
import History from '../../organisms/history/history'
import SectionContainer from '../../molecules/section-container/sectionContainer'
import Axis from '../../organisms/axis/axis'
import Carousel from '../../organisms/carousel/carousel'
import TabsSection from '../../molecules/tabs-section/tabsSection'
import ContentRotator from '../../molecules/content-rotator/contentRotator'
import CoursesSection from '../../organisms/courses-section/coursesSection'
import ResultsCardList from '../../organisms/results-card-list/resultsCardList'
import HistoryLink from '../../organisms/history-link/historyLink'
import Maps from '../../organisms/maps/maps'
import MapSedeInfo from '../../organisms/map-sede-info/mapSedeInfo'
import CircularSlider from '../../organisms/circular-slider/circularSlider'
import SimpleDescription from '../../molecules/simple-description/simpleDescription'
import DocumentsPlayer from "../../molecules/documents-player/documentsPlayer"
import VideosPlayer from '../../molecules/videos-player/videosPlayer'
import AudiosPlayer from "../../molecules/audios-player/audiosPlayer"
import ImagesSwitcher from '../../organisms/images-switcher/imagesSwitcher'
import ScrollParallax from '../../organisms/scroll-parallax/scrollParallax'
import Redirection from '../../atoms/redirection/redirection'
import Map from '../../organisms/map/map'
import Featured from "../../molecules/featured/featured";
import Infographic from "../../organisms/infographic/infographic";
import SimpleCards from "../../molecules/simple-cards/simpleCards";
import SimpleBanner from "../../atoms/simple-banner/simpleBanner";
import CarouselAlgoritmo from '../../organisms/carousel-algoritmo/carouselAlgoritmo'
import BotoneraHome from '../../organisms/botonera-home/botoneraHome'
import HoverImages from '../../organisms/hover-images/hoverImages'
import SmallCards from '../../organisms/small-cards/smallCards'
import FormLibranzas from '../../organisms/form-libranzas/formLibranzas'
import HistoryLinkClaustro from '../../organisms/history-link-claustro/historyLinkClaustro'
import BannerInforme from '../../organisms/banner-informe/bannerInforme'
import DescriptionInforme from '../../organisms/description-informe/descriptionInforme'
import HowItWorksSection from '../../molecules/how-it-works/how-it-works'
import FormMentoria from '../../organisms/form-mentoria/formMentoria'
import PressNews from "../../organisms/press-news/pressNews";
import MultiGallery from "../../organisms/multi-gallery/multiGallery";
import VideosDownloader from "../../molecules/videos-downloader/videosDownloader"
import Bulletin from "../../organisms/bulletin/bulletin";
import Journey from '../../organisms/journey/journey'
import Projects from '../../organisms/projects/projects'
import MapCards from '../../molecules/map-cards/mapCards'

interface LibraryInterface {
   content: ReferenciaContenido;
   categoryName: string;
}

const LibraryComponents = (props: LibraryInterface) => {

   const refContent = props.content;
   const categoryName = props.categoryName;

   switch (props.content.tipoComponente) {
      case 'AgregadosCategoria':
         return <GridCardsSection {...refContent} nombreCategoria={categoryName} />
      case 'InformacionInstitucional':
         return <CardColumns {...refContent} nombreCategoria={categoryName} />
      case 'Wellness':
         return <ContentLeftRight {...refContent} nombreCategoria={categoryName} />
      case 'Galeria':
         return <Gallery {...refContent} nombreCategoria={categoryName} />
      case 'GaleriaExtendida':
         return <GalleryExtended {...refContent} nombreCategoria={categoryName} />
      case 'Destacados':
         return <VideoLink {...refContent} nombreCategoria={categoryName} />
      case 'DestacadoParaTi':
         return <GalleryCards {...refContent} nombreCategoria={categoryName} />
      case 'Beneficios':
         return <SubsectionContainer {...refContent} nombreCategoria={categoryName} />
      case 'Publicidad':
         return <DiscoverAppSection {...refContent} nombreCategoria={categoryName} />
      case 'DocumentosInteres':
         return <DownloadsList {...refContent} nombreCategoria={categoryName} />
      case 'NuestrasSedes':
         return <OfficesList {...refContent} nombreCategoria={categoryName} />
      case 'ContenidoEnriquecido':
         return <Richtext {...refContent} nombreCategoria={categoryName} />
      case 'VideoService':
         return <VideoService {...refContent} nombreCategoria={categoryName} />
      case 'PreguntasFrecuentes':
         return <FrequentlyAskedQuestions {...refContent} nombreCategoria={categoryName} />
      case 'ContenidoEnriquecidoArticulo':
         return <ArticleContentDescription {...refContent} nombreCategoria={categoryName} />
      case 'Spotify':
         return <SpotifyListen  {...refContent} nombreCategoria={categoryName} />
      case 'TiempoLectura':
         return <Readtime   {...refContent} nombreCategoria={categoryName} />
      case 'Tarifas':
         return <PriceInformation  {...refContent} nombreCategoria={categoryName} />
      case 'Historia':
         return <History {...refContent} nombreCategoria={categoryName} />
      case 'SectionContainer':
         return <SectionContainer {...refContent} nombreCategoria={categoryName} />
      case 'Ejes':
         return <Axis {...refContent} nombreCategoria={categoryName} />
      case 'GaleriaPrincipal':
         return <Carousel {...refContent} nombreCategoria={categoryName} />
      case 'SeccionTabs':
         return <TabsSection {...refContent} nombreCategoria={categoryName} />
      case 'RotadorPrincipal':
         return <ContentRotator {...refContent} nombreCategoria={categoryName} />
      case 'SeccionCursos':
         return <CoursesSection {...refContent} nombreCategoria={categoryName} />
      case 'Cartas':
         return <ResultsCardList {...refContent} nombreCategoria={categoryName} />
      case 'LineaTiempo':
         return <HistoryLink {...refContent} nombreCategoria={categoryName} />
      case 'Mapa':
         return <Maps {...refContent} nombreCategoria={categoryName} />
      case "MapaSedeInfo":
         return <MapSedeInfo {...refContent} nombreCategoria={categoryName} />;
      case 'SliderCircular':
         return <CircularSlider {...refContent} nombreCategoria={categoryName} />
      case 'Descripcion':
         return <SimpleDescription {...refContent} nombreCategoria={categoryName} />
      case "RotadorDocumentos":
         return <DocumentsPlayer {...refContent} nombreCategoria={categoryName} />;
      case "ReproductorVideos":
         return <VideosPlayer {...refContent} nombreCategoria={categoryName} />;
      case "ReproductorAudios":
         return <AudiosPlayer {...refContent} nombreCategoria={categoryName} />;
      case "SwitcherImagenes":
         return <ImagesSwitcher {...refContent} nombreCategoria={categoryName} />;
      case "ScrollParallax":
         return <ScrollParallax {...refContent} nombreCategoria={categoryName} />;
      case "Redireccion":
         return <Redirection {...refContent} nombreCategoria={categoryName} />;
      case "MapaSimple":
         return <Map {...refContent} nombreCategoria={categoryName} />;
      case "DestacadosHome":
         return <Featured {...refContent} nombreCategoria={categoryName} />;
      case "Infografia":
         return <Infographic {...refContent} nombreCategoria={categoryName} />;
      case "Tarjetas":
         return <SimpleCards {...refContent} nombreCategoria={categoryName} />;
      case "Banner":
         return <SimpleBanner {...refContent} nombreCategoria={categoryName} />;
      case "CarouselAlgoritmo":
         return <CarouselAlgoritmo {...refContent} nombreCategoria={categoryName} />
      case "BotoneraHome":
         return <BotoneraHome {...refContent} nombreCategoria={categoryName} />
      case "ImagenesHover":
         return <HoverImages {...refContent} nombreCategoria={categoryName} />
      case "SmallCards":
         return <SmallCards {...refContent} nombreCategoria={categoryName} />
      case "FormLibranzas":
         return <FormLibranzas {...refContent} nombreCategoria={categoryName} />;
      case 'LineaTiempoClaustro':
         return <HistoryLinkClaustro {...refContent} nombreCategoria={categoryName} />
      case 'BannerInforme':
         return <BannerInforme {...refContent} nombreCategoria={categoryName} />
      case 'DescriptionInforme':
         return <DescriptionInforme {...refContent} nombreCategoria={categoryName} />
      case "AnuncioPrincipal":
         return (
            <HowItWorksSection {...refContent} nombreCategoria={categoryName} />
         );
      case "FormularioMentoria":
         return <FormMentoria {...refContent} nombreCategoria={categoryName} />;
      case "NotasPrensa":
         return <PressNews {...refContent} nombreCategoria={categoryName} />;
      case "GaleriaMultiple":
         return <MultiGallery {...refContent} nombreCategoria={categoryName} />;
      case "DescargarVideos":
         return <VideosDownloader {...refContent} nombreCategoria={categoryName}/>;
      case "Boletin":
         return <Bulletin {...refContent} nombreCategoria={categoryName}/>;
      case 'Journey' :
         return <Journey { ...refContent } nombreCategoria={ categoryName } />
      case 'Proyectos' :
         return <Projects { ...refContent } nombreCategoria={ categoryName } />
      case 'MapaCards' :
         return <MapCards { ...refContent } nombreCategoria={ categoryName } />
   }

   return (<></>)
}

export default LibraryComponents;
